import { render, staticRenderFns } from "./DashboardHintOffer.vue?vue&type=template&id=1200fc26&scoped=true"
import script from "./DashboardHintOffer.vue?vue&type=script&lang=ts"
export * from "./DashboardHintOffer.vue?vue&type=script&lang=ts"
import style0 from "./DashboardHintOffer.vue?vue&type=style&index=0&id=1200fc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1200fc26",
  null
  
)

export default component.exports